const LEVELS = {
  INFO: 0,
  MID: 5,
  HIGH: 10,
  DANGER: 15,
}

export default LEVELS
